// API bindings: mail (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl } from "./utils";
import { SendCallMailRequest, ShareCallMailRequest } from "./definitions";

export class ApiMail {
    /**
     * Method: POST
     * Path: /mail/call
     * Send call transcription and summary email
     * @param body Body parameters
     * @returns The request parameters
     */
    public static SendCallTranscriptionAndSummaryEmail(body: SendCallMailRequest): RequestParams<void, SendCallTranscriptionAndSummaryEmailErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/mail/call`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "RECORD_NOT_FOUND", handler.notFoundRecordNotFound)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /mail/call/share
     * Share call invitation by email
     * @param body Body parameters
     * @returns The request parameters
     */
    public static ShareCallByEmail(body: ShareCallMailRequest): RequestParams<void, ShareCallByEmailErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/mail/call/share`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Error handler for SendCallTranscriptionAndSummaryEmail
 */
export type SendCallTranscriptionAndSummaryEmailErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * Handler for status = 404 and code = RECORD_NOT_FOUND
     */
    notFoundRecordNotFound: () => void;
};

/**
 * Error handler for ShareCallByEmail
 */
export type ShareCallByEmailErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;
};

